module.exports = __webpack_public_path__ + "images/corners/Apollo.b9146986a87c1a8c60326098a30a1378.jpg";